import Exercises from './Exercises';
import WorkoutImages from './WorkoutImages';

const KirbyFlexWorkout = {
  name: 'Kirby Flex',
  img: WorkoutImages.KirbyFlex,
  description: 'flatten your fingers',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 2,
    flexor: 2,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
  ],
};

const SonicSpeedWorkout = {
  name: 'Sonic Speed',
  img: WorkoutImages.SonicSpeed,
  description: 'move your fingers in new ways',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 1,
    index: 1,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.indexFingerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.pinkyFingerStretch,
    },
  ],
};

const GenjiHandsWorkout = {
  name: 'Genji Hands',
  img: WorkoutImages.GenjiHands,
  description: 'shuriken ninja fingers',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.prayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.reversePrayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
  ],
};

const KratosCritsWorkout = {
  name: 'Kratos Crits',
  img: WorkoutImages.KratosCrits,
  description: 'intense burn for full power attacks',
  time: 420,
  targets: {
    thumb: 2,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 4,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipLiftsWithBlock,
    },
  ],
};

const HammerDownWorkout = {
  name: 'Hammer Down',
  img: WorkoutImages.HammerDown,
  description: 'full hand force',
  time: 480,
  targets: {
    thumb: 3,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToPinky,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristFlips,
    },
  ],
};

const GanonCannonsWorkout = {
  name: 'Ganon Cannons',
  img: WorkoutImages.GanonCannons,
  description: 'explosive power unleashed',
  time: 420,
  targets: {
    thumb: 2,
    wrist: 2,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristFlexion,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const MasterChiefWorkout = {
  name: 'Master Chief',
  img: WorkoutImages.MasterChief,
  description: 'take your squad further',
  time: 630,
  targets: {
    thumb: 2,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 4,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipLiftsWithBlock,
    },
  ],
};

const TombRaiderWorkout = {
  name: 'Tomb Raider',
  img: WorkoutImages.TombRaider,
  description: 'endless plunder awaits',
  time: 720,
  targets: {
    thumb: 3,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbToPinky,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlips,
    },
  ],
};

const EndlessScrollerWorkout = {
  name: 'Endless Scroller',
  img: WorkoutImages.EndlessScroller,
  description: 'will the levels ever end',
  time: 630,
  targets: {
    thumb: 2,
    wrist: 1,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristFlexion,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const ExperienceTranquilityWorkout = {
  name: 'Experience Tranquility',
  img: WorkoutImages.ExperienceTranquility,
  description: 'peace for your hands',
  time: 180,
  targets: {
    thumb: 0,
    wrist: 3,
    flexor: 2,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.dynamicWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristFlexion,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.openHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.closedHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.snuffBoxSelfMassage,
    },
  ],
};

const TheMedicWorkout = {
  name: 'The Medic',
  img: WorkoutImages.TheMedic,
  description: 'immediate relief any time',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 1,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.outstretchedFingersWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.fingerPulls,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.shakeItOut,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.palmFlips,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
  ],
};

const ValhallaWorkout = {
  name: 'Valhalla',
  img: WorkoutImages.Valhalla,
  description: 'where warriors take their rest',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 1,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.watchWinders,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.finkelsteinStretch,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.lacedHandSqueeze,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
  ],
};

const EndermanWorkout = {
  name: 'Enderman',
  img: WorkoutImages.Enderman,
  description: 'slender finger stretch',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 2,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
  ],
};

const MisterFantasticWorkout = {
  name: 'Mister Fantastic',
  img: WorkoutImages.MisterFantastic,
  description: 'send the bend',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 2,
    pinky: 1,
    index: 1,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.prayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.reversePrayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.indexFingerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.pinkyFingerStretch,
    },
  ],
};

const WaveDashWorkout = {
  name: 'Wave Dash',
  img: WorkoutImages.WaveDash,
  description: 'light as a feather',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 2,
    flexor: 2,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
  ],
};

const FullCounterWorkout = {
  name: 'Full Counter',
  img: WorkoutImages.FullCounter,
  description: 'reaction mana replenished',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.prayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.reversePrayerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
  ],
};

const EvasiveStrikeWorkout = {
  name: 'Evasive Strike',
  img: WorkoutImages.EvasiveStrike,
  description: 'bullets can\'t touch you',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 2,
    flexor: 2,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerFlexionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.singleFingerExtensionStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
  ],
};

const PlasticManWorkout = {
  name: 'Plastic Man',
  img: WorkoutImages.PlasticMan,
  description: 'finger placement anywhere',
  time: 450,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 1,
    extensor: 1,
    fingers: 2,
    pinky: 1,
    index: 1,
    lumbrical: 1,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingFlexorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.standingExtensorMassStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.lumbricalStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.indexFingerStretch,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.pinkyFingerStretch,
    },
  ],
};

const HulkSmashWorkout = {
  name: 'Hulk Smash',
  img: WorkoutImages.HulkSmash,
  description: 'power up player',
  time: 420,
  targets: {
    thumb: 3,
    wrist: 1,
    flexor: 1,
    extensor: 1,
    fingers: 1,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToPinky,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristFlexion,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const KeySmasherWorkout = {
  name: 'Key Smasher',
  img: WorkoutImages.KeySmasher,
  description: 'prepare your keyboard',
  time: 420,
  targets: {
    thumb: 2,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 4,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const JuggernaughtWorkout = {
  name: 'Juggernaught',
  img: WorkoutImages.Juggernaught,
  description: 'absolute battlefield domination',
  time: 480,
  targets: {
    thumb: 2,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristFlips,
    },
  ],
};

const MasterSwordWorkout = {
  name: 'Master Sword',
  img: WorkoutImages.MasterSword,
  description: 'no other workout like this',
  time: 480,
  targets: {
    thumb: 2,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.wristFlips,
    },
  ],
};

const SuperNovaWorkout = {
  name: 'Super Nova',
  img: WorkoutImages.SuperNova,
  description: 'enormour power uncaged',
  time: 420,
  targets: {
    thumb: 3,
    wrist: 1,
    flexor: 1,
    extensor: 1,
    fingers: 1,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbToPinky,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const ForcePushWorkout = {
  name: 'Force Push',
  img: WorkoutImages.ForcePush,
  description: 'the power of the force',
  time: 420,
  targets: {
    thumb: 2,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 4,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets of 10 reps',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const TheGulagWorkout = {
  name: 'The Gulag',
  img: WorkoutImages.TheGulag,
  description: 'escape from your demise',
  time: 630,
  targets: {
    thumb: 3,
    wrist: 1,
    flexor: 0,
    extensor: 1,
    fingers: 1,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristFlexion,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const DarkSoulsWorkout = {
  name: 'Dark Souls',
  img: WorkoutImages.DarkSouls,
  description: 'prepare for your battles',
  time: 720,
  targets: {
    thumb: 2,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlips,
    },
  ],
};

const CircleClosingInWorkout = {
  name: 'Circle Closing In',
  img: WorkoutImages.CircleClosingIn,
  description: 'winners circle unlocked',
  time: 630,
  targets: {
    thumb: 3,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbsUp,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbTipToTip,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const KillStreakWorkout = {
  name: 'Kill Streak',
  img: WorkoutImages.KillStreak,
  description: 'kill montages made easy',
  time: 720,
  targets: {
    thumb: 2,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.wristFlips,
    },
  ],
};

const RainbowRoadWorkout = {
  name: 'Rainbow Road',
  img: WorkoutImages.RainbowRoad,
  description: 'endless drift road',
  time: 630,
  targets: {
    thumb: 2,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 4,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.forearmWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbToFingerBase,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.tableTopUprights,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.soloFingerCurls,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerClaws,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const PacManWorkout = {
  name: 'Pac-Man',
  img: WorkoutImages.PacMan,
  description: 'your fingers will be hungry',
  time: 630,
  targets: {
    thumb: 2,
    wrist: 1,
    flexor: 0,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbOpposition,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.thumbWindshieldWipers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.fingerSpreads,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.rocketfellers,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.closedHandWristExtension,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.openHandWristFlexion,
    },
    {
      directions: '3 sets - hold for 30 seconds',
      exercise: Exercises.isolatedFingertipCurlsWithBlock,
    },
  ],
};

const MedKitWorkout = {
  name: 'Med Kit',
  img: WorkoutImages.MedKit,
  description: 'quick set for quick relief',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 1,
    flexor: 0,
    extensor: 1,
    fingers: 3,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.outstretchedFingersWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.fingerPulls,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.shakeItOut,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
  ],
};

const QuickReviveWorkout = {
  name: 'Quick Revive',
  img: WorkoutImages.QuickRevive,
  description: 'when you need it most',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.dynamicWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristFlexion,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.palmFlips,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
  ],
};

const PokeCenterWorkout = {
  name: 'Poke Center',
  img: WorkoutImages.PokeCenter,
  description: 'a full heal when you hurt',
  time: 180,
  targets: {
    thumb: 0,
    wrist: 1,
    flexor: 0,
    extensor: 1,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.outstretchedFingersWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.fingerPulls,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.shakeItOut,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.openHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.closedHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.snuffBoxSelfMassage,
    },
  ],
};

const PainKillersWorkout = {
  name: 'Pain Killers',
  img: WorkoutImages.PainKillers,
  description: 'pop knuckles not pills',
  time: 180,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 0,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.watchWinders,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.finkelsteinStretch,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.lacedHandSqueeze,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.openHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.closedHandCircles,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.snuffBoxSelfMassage,
    },
  ],
};

const NukaColaWorkout = {
  name: 'Nuka Cola',
  img: WorkoutImages.NukaCola,
  description: 'radiate your pain away',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 0,
    flexor: 0,
    extensor: 0,
    fingers: 1,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.watchWinders,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.finkelsteinStretch,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.lacedHandSqueeze,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
  ],
};

const HeartContainerWorkout = {
  name: 'Heart Container',
  img: WorkoutImages.HeartContainer,
  description: 'fill up your relief meter',
  time: 150,
  targets: {
    thumb: 0,
    wrist: 3,
    flexor: 0,
    extensor: 2,
    fingers: 2,
    pinky: 0,
    index: 0,
    lumbrical: 0,
  },
  exercises: [
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.dynamicWristFlexionAndExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristFlexion,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.rapidFingerSpreadsInWristExtension,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.palmFlips,
    },
    {
      directions: '1 set of 20 reps',
      exercise: Exercises.knuckleSelfMassage,
    },
  ],
};

const ByName = [
  KirbyFlexWorkout,
  SonicSpeedWorkout,
  GenjiHandsWorkout,
  KratosCritsWorkout,
  HammerDownWorkout,
  GanonCannonsWorkout,
  MasterChiefWorkout,
  TombRaiderWorkout,
  EndlessScrollerWorkout,
  ExperienceTranquilityWorkout,
  TheMedicWorkout,
  ValhallaWorkout,
  EndermanWorkout,
  MisterFantasticWorkout,
  WaveDashWorkout,
  FullCounterWorkout,
  EvasiveStrikeWorkout,
  PlasticManWorkout,
  HulkSmashWorkout,
  KeySmasherWorkout,
  JuggernaughtWorkout,
  MasterSwordWorkout,
  SuperNovaWorkout,
  ForcePushWorkout,
  TheGulagWorkout,
  DarkSoulsWorkout,
  CircleClosingInWorkout,
  KillStreakWorkout,
  RainbowRoadWorkout,
  PacManWorkout,
  MedKitWorkout,
  QuickReviveWorkout,
  PokeCenterWorkout,
  PainKillersWorkout,
  NukaColaWorkout,
  HeartContainerWorkout,
];

const ByType = [
  {
    type: 'flexibility',
    workouts: [
      KirbyFlexWorkout,
      SonicSpeedWorkout,
      GenjiHandsWorkout,
      EndermanWorkout,
      MisterFantasticWorkout,
      WaveDashWorkout,
      FullCounterWorkout,
      EvasiveStrikeWorkout,
      PlasticManWorkout,
    ],
  },
  {
    type: 'strength',
    workouts: [
      KratosCritsWorkout,
      HammerDownWorkout,
      GanonCannonsWorkout,
      HulkSmashWorkout,
      KeySmasherWorkout,
      JuggernaughtWorkout,
      MasterSwordWorkout,
      SuperNovaWorkout,
      ForcePushWorkout,
    ],
  },
  {
    type: 'endurance',
    workouts: [
      MasterChiefWorkout,
      TombRaiderWorkout,
      EndlessScrollerWorkout,
      TheGulagWorkout,
      DarkSoulsWorkout,
      CircleClosingInWorkout,
      KillStreakWorkout,
      RainbowRoadWorkout,
      PacManWorkout,
    ],
  },
  {
    type: 'painrelief',
    workouts: [
      ExperienceTranquilityWorkout,
      TheMedicWorkout,
      ValhallaWorkout,
      MedKitWorkout,
      QuickReviveWorkout,
      PokeCenterWorkout,
      PainKillersWorkout,
      NukaColaWorkout,
      HeartContainerWorkout,
    ],
  },
];

const Workouts = {
  ByName,
  ByType,
};

export default Workouts;
